import { n as noop_1 } from './noop-9247c8ef.js';

const sleep = (ms = 0) => new Promise((res) => setTimeout(res, ms));
const allFinished = (promisesArray) => Promise.all(promisesArray.map((promise) => promise.catch(noop_1)));

export { allFinished as a, sleep as s };
